// extracted by mini-css-extract-plugin
module.exports = {"audios_container":"style_audios_container__1drcg","audios":"style_audios__2iex4"};